export default __webpack_public_path__ + "static/media/banner-latam-silicon-valley.e061e727.jpg";